export enum FileExtension {
  jpg = 'jpg',
  jpeg = 'jpeg',
  gif = 'gif',
  webp = 'webp',
  png = 'png',
  mpg = 'mpg',
  avi = 'avi',
  mp4 = 'mp4',
  pdf = 'pdf',
  doc = 'doc',
  docx = 'docx',
  svg = 'svg',
}
